import { render, staticRenderFns } from "./ListStock.vue?vue&type=template&id=4816a81e&"
import script from "./ListStock.vue?vue&type=script&lang=js&"
export * from "./ListStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports